export enum GoalTypeEnum {
    TextBasedGoal = 1,
    GroupGoal = 2,
    NumericGoal = 3,
    CustomGoal = 4
}